import type { ProcurementFilters } from '../api/procurements'

// The fields a saved filter's definition actually covers — kept in sync with
// the fields DashboardView.selectSavedFilter() copies out of filterConfig
// when populating the draft filters. Fields the Advanced filters panel
// doesn't expose (sort/limit/offset/archived/filterId/...) can never diverge
// from the saved definition and are intentionally excluded.
const COMPARED_FIELDS = [
  'search',
  'sourceId',
  'status',
  'procurementType',
  'country',
  'cpv',
  'minAiScore',
  'minValueEur',
  'maxValueEur',
  'currency',
] as const satisfies readonly (keyof ProcurementFilters)[]

// `null`, `undefined` and `''` all mean "unset" across these fields — Svelte's
// bind:value leaves a cleared <input type="number"> as `null` (see the
// comment on ProcurementFilters.minAiScore) while a cleared text input or an
// "All"/unset Dropdown selection is `''`/`undefined` — so they must compare
// equal regardless of which "empty" shape produced them.
function normalize(value: unknown): string | number | undefined {
  return value === null || value === undefined || value === ''
    ? undefined
    : (value as string | number)
}

/**
 * True when `current`'s comparable fields no longer match `saved` — i.e. the
 * user has edited the Advanced filters panel since picking this saved
 * filter, including filling in a field the saved filter left empty.
 */
export function isFilterModified(current: ProcurementFilters, saved: ProcurementFilters): boolean {
  return COMPARED_FIELDS.some((field) => normalize(current[field]) !== normalize(saved[field]))
}
